import * as Pusher from "pusher-js";

export default (
  app: any,
  { apiKey, options }: { apiKey: string; options: any }
) => {
  app.provide("pusher", new Pusher.default(apiKey, options));
};
